export const transition = {
    duration: 1,
    ease: [.56, .03, .12, 1.04],
};

export const variants = {
    offscreen: windowWidth => ({
        opacity: 0,
        x: windowWidth <= 600 ? 0 : '4rem',
    }),
    onscreen: {
        opacity: 1,
        x: 0,
    }
}

export const smallScreenVariants = {
    offscreen: windowWidth => ({
        opacity: 0,
        x: windowWidth <= 600 ? 0 : '2rem',
    }),
    onscreen: {
        opacity: 1,
        x: 0,
    }
}